import { LogoPrecisionEngineeringBackendAws, LogoPrecisionEngineeringBackendAzure, LogoPrecisionEngineeringBackendGoogleCloud, LogoPrecisionEngineeringBackendNodejs, LogoPrecisionEngineeringBackendPostgreSql, LogoPrecisionEngineeringFrontendHtml, LogoPrecisionEngineeringFrontendJavascript, LogoPrecisionEngineeringFrontendNextjs, LogoPrecisionEngineeringFrontendReact, LogoPrecisionEngineeringFrontendTypescript, LogoPrecisionEngineeringGenAiDeepseek, LogoPrecisionEngineeringGenAiGemini, LogoPrecisionEngineeringGenAiHubspot, LogoPrecisionEngineeringGenAiOpenai, LogoPrecisionEngineeringGenAiZapier, LogoPrecisionEngineeringMobileDevAndroid, LogoPrecisionEngineeringMobileDevExpo, LogoPrecisionEngineeringMobileDevFlutter, LogoPrecisionEngineeringMobileDevIos, LogoPrecisionEngineeringMobileDevReactNative } from "@/lib/images";
import { StaticImageData } from "next/image";

export const Heading_Section_Precision_Engineering = {
    heading : "Precision Engineering for Business Success"
}

export const Sub_Heading_Section_Precision_Engineering = {
    devkrest_delivers : "Devkrest delivers precision engineering solutions using the latest technologies, ensuring scalable, efficient, ",
    and_tailored : "and tailored systems for business success. Our tech stack is built to optimize performance and drive growth ",
    across_all : "across all platforms."
}

interface ILogo {
    logo? : StaticImageData;
    logo_alt? : string;
}

interface ITechStackPrecisionEngineering {
    title : string;
    logo_img : ILogo[];
    align : string
}

export const Tech_Stack_Section_Precision_Engineering : ITechStackPrecisionEngineering[] = [
    {
        title: "Frontend Technologies",
        align: "items-start",
        logo_img:[
            {logo:LogoPrecisionEngineeringFrontendReact, logo_alt:"Frontend React"},
            {logo:LogoPrecisionEngineeringFrontendNextjs, logo_alt:"Frontend Next JS"},
            {logo:LogoPrecisionEngineeringFrontendHtml, logo_alt:"Frontend Html"},
            {logo:LogoPrecisionEngineeringFrontendTypescript, logo_alt:"Frontend Typescript"},
            {logo:LogoPrecisionEngineeringFrontendJavascript, logo_alt:"Frontend Javascript"},
        ]
    },
        {
        title: "Gen-AI & Automation Services",
        align: "items-end",
        logo_img:[
            {logo:LogoPrecisionEngineeringGenAiGemini, logo_alt:"GenAi Gemini"},
            {logo:LogoPrecisionEngineeringGenAiDeepseek, logo_alt:"Gen AI Deepseek"},
            {logo:LogoPrecisionEngineeringGenAiOpenai, logo_alt:"Gem AI Open AI"},
            {},
            {logo:LogoPrecisionEngineeringGenAiHubspot, logo_alt:"Gen AI Hubspot"},
            {logo:LogoPrecisionEngineeringGenAiZapier, logo_alt:"Gen AI Zapier"},
        ]
    },
        {
        title: "Backend & Cloud Solutions",
        align: "items-start",
        logo_img:[
            {logo:LogoPrecisionEngineeringBackendGoogleCloud, logo_alt:"Backend Google Cloud"},
            {logo:LogoPrecisionEngineeringBackendPostgreSql, logo_alt:"Backend Postgre Sql"},
            {logo:LogoPrecisionEngineeringBackendAws, logo_alt:"Backend AWS"},
            {logo:LogoPrecisionEngineeringBackendNodejs, logo_alt:"Backend Node Js"},
            {logo:LogoPrecisionEngineeringBackendAzure, logo_alt:"Backend Azure"},
        ]
    },
        {
        title: "Mobile App Technologies",
        align: "items-end",
        logo_img:[
            {},
            {logo:LogoPrecisionEngineeringMobileDevReactNative, logo_alt:"Mobile Dev React Native"},
            {logo:LogoPrecisionEngineeringMobileDevExpo, logo_alt:"Mobile Dev Expo"},
            {logo:LogoPrecisionEngineeringMobileDevFlutter, logo_alt:"Mobile Dev Flutter"},
            {logo:LogoPrecisionEngineeringMobileDevAndroid, logo_alt:"Mobile Dev Android"},
            {logo:LogoPrecisionEngineeringMobileDevIos, logo_alt:"Mobile Dev Ios"},
        ]
    },

]